interface NavbarProps {
  scrolled: boolean;
}

export default function Navbar({ scrolled }: NavbarProps) {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="max-w-[1280px] mx-auto px-20 py-6 flex items-center justify-between">
        <div className="flex items-center gap-3 cursor-pointer" onClick={() => scrollToSection('home')}>
          <img 
            src="https://public.readdy.ai/ai/img_res/5fc1b067-0b0c-4e27-9d09-cc15c74c3cca.png" 
            alt="SAID LTDA Logo" 
            className="h-10 w-10 object-contain"
          />
          <span className={`text-xl font-bold tracking-wider ${scrolled ? 'text-[#1a1a1a]' : 'text-white'}`}>
            SAID LTDA
          </span>
        </div>
        
        <div className="flex items-center gap-12">
          <button
            onClick={() => scrollToSection('home')}
            className={`text-base font-medium transition-colors hover:text-[#0066ff] whitespace-nowrap ${
              scrolled ? 'text-[#1a1a1a]' : 'text-white'
            }`}
          >
            Home
          </button>
          <button
            onClick={() => scrollToSection('vpn-service')}
            className={`text-base font-medium transition-colors hover:text-[#0066ff] whitespace-nowrap ${
              scrolled ? 'text-[#1a1a1a]' : 'text-white'
            }`}
          >
            VPN Service
          </button>
          <button
            onClick={() => scrollToSection('features')}
            className={`text-base font-medium transition-colors hover:text-[#0066ff] whitespace-nowrap ${
              scrolled ? 'text-[#1a1a1a]' : 'text-white'
            }`}
          >
            Features
          </button>
          <button
            onClick={() => scrollToSection('contact')}
            className={`text-base font-medium transition-colors hover:text-[#0066ff] whitespace-nowrap ${
              scrolled ? 'text-[#1a1a1a]' : 'text-white'
            }`}
          >
            Contact
          </button>
          <button
            onClick={() => scrollToSection('about')}
            className={`text-base font-medium transition-colors hover:text-[#0066ff] whitespace-nowrap ${
              scrolled ? 'text-[#1a1a1a]' : 'text-white'
            }`}
          >
            About Us
          </button>
        </div>
      </div>
    </nav>
  );
}
